import React from 'react';
import PropTypes from 'prop-types';
import StyledButton from './styled';

const IconButton = ({
  children,
  onClick
}) => /*#__PURE__*/React.createElement(StyledButton, {
  type: "button",
  onClick: onClick
}, children);

IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};
IconButton.defaultProps = {
  onClick: () => {}
};
export default IconButton;